import { configureStore } from '@reduxjs/toolkit';

import { CartReducer } from '../Reducers/CartReducer';
import { ProfileReducer } from '../Reducers/ProfileReducer';
import { EnvironmentSettingsReducer } from '../Reducers/EnvironmentSettingsReducer';
import { NavigationReducer } from '../Reducers/NavigationReducer';
import { TextsReducer } from '../Reducers/TextsReducer';
import { CustomAttributesReducer } from '../Reducers/CustomAttributesReducer';

const appStore = configureStore({
  reducer: {
    NavigationReducer: NavigationReducer.reducer,
    CartReducer: CartReducer.reducer,
    ProfileReducer: ProfileReducer.reducer,
    TextsReducer: TextsReducer.reducer,
    EnvironmentSettingsReducer: EnvironmentSettingsReducer.reducer,
    CustomAttributesReducer: CustomAttributesReducer.reducer,
  },
});

export default appStore;

export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;
